import styled, { css } from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as Group } from 'assets/images/group.svg';
import { ReactComponent as Guest } from 'assets/images/invite.svg';

export const Container = styled.div`
  padding-bottom: 16px;
`;

const textStyle = css`
  font-size: 12px;
  line-height: 1.5;
  color: ${ColorPalette.HEX.DimGray};
  margin-top: 8px;
`;

export const Text = styled.span`
  ${textStyle}
`;

export const TravelerName = styled.span`
  ${textStyle}
  font-weight: 600;
  margin-right: 5px;
`;

interface StyledProps {
  $adminView?: boolean;
}

export const TravelerGroup = styled.span<StyledProps>`
  ${textStyle}
  color: ${ColorPalette.HEX.Manatee};
  display: flex;
  ${({ $adminView }) => $adminView && 'margin-top: 4px'}
`;

export const Value = styled.span`
  ${textStyle}
  margin-left: auto;
  font-size: 10px;
  font-weight: 600;

  & > b {
    font-size: 12px;
  }
`;

export const GroupIcon = styled(Group)`
  margin-right: 4px;
`;

export const GuestIcon = styled(Guest)`
  margin-right: 4px;
`;
